import React, { useEffect, useState } from "react";
import { Background } from "./Login/LoginComp";
import { FloatLabelInput, LoadingButton } from "../Utils/CustomComponent";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import axiosInstance from "../axios";
import urls from "../Utils/urls";
import { toast } from "react-toastify";
import { Alert } from "react-bootstrap";
import { oracleConfig } from "../Utils/constant";

const UnsubscribeTicket = () => {
  const [disableFWS, setDisableFWS] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const { ticketId, ticketNumber } = useParams();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    if (
      ticketNumber &&
      ticketNumber !== "null" &&
      ticketNumber !== "undefined"
    ) {
      setValue("ticketNumber", ticketNumber);
    }
  }, [ticketNumber, setValue]);

  const watchValue = watch();

  async function onSubmit(data) {
    setDisableFWS(true);
    try {
      const data2 = {
        email: data.email,
        ticketId: ticketId,
      };

      const res = await axiosInstance.post(
        urls.support.unsubscribeTicket,
        data2,
        oracleConfig
      );

      if (res.status == 200) {
        toast.success(
          `You have been successfully unsubscribed from ${ticketNumber} updates!`,
          {
            closeOnClick: true,
            autoClose: 6000,
            pauseOnFocusLoss: false,
            draggable: false,
            pauseOnHover: false,
          }
        );
        setShowAlert(true);
      }
    } catch (error) {
      console.error(error);
      toast.error("Some error occured! Please try again.");
    } finally {
      setDisableFWS(false);
    }
  }

  return (
    <Background>
      <form className="w-75">
        <h3>Unsubscribe from Ticket Updates</h3>
        <p className="pb-5 mb-3">
          Enter your email to stop receiving ticket updates.
        </p>
        {showAlert && (
          <Alert variant={"success"}>
            You’ve successfully unsubscribed from updates related to ticket{" "}
            <span className="fw-bold">{ticketNumber}</span>!
          </Alert>
        )}
        <div className="form-outline mb-5">
          <FloatLabelInput
            register={{
              ...register("email", {
                required: true,
                pattern:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            label={"Email"}
            value={watchValue?.email}
            disabled={disableFWS}
            defaultValue={""}
            error={errors.email ? "Email Required" : ""}
            type="email"
          />
        </div>
        <div className="form-outline mb-1">
          {/* <InputGroup> */}
          <FloatLabelInput
            register={{ ...register("ticketNumber", { required: true }) }}
            label={"Ticket Number"}
            value={ticketNumber}
            disabled={true}
            error={errors.ticketNumber ? "Ticket Number Required" : ""}
            type={"text"}
          />
        </div>

        <div className="text-center pt-1 mt-5 mb-5 pb-1">
          <LoadingButton
            className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
            type="button"
            onClick={handleSubmit(onSubmit)}
            title={"Unsubscribe"}
            disabled={disableFWS}
            loading={disableFWS}
          />

          {promptFail && (
            <div className="alert alert-error" role="alert">
              {promptFail}
            </div>
          )}
          <br />
        </div>
      </form>
    </Background>
  );
};

export default UnsubscribeTicket;
